import React, { useRef, useEffect } from "react";
import { Icon, Menu } from "semantic-ui-react";

interface ICustomContextMenu {
  x: number;
  y: number;
  url: string;
  closePopup: (value: boolean) => void;
}

export const CustomContextMenu = ({ x, y, url, closePopup }: ICustomContextMenu) => {
  const popupRef = useRef<HTMLDivElement | null>(null);

  const handlePopupClick = () => {
    window.open(url, "_blank");
    closePopup(false);
  };

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        closePopup(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [closePopup]);

  return (
    <div ref={popupRef}>
      <Menu
        vertical
        style={{
          position: "fixed",
          zIndex: 2,
          top: y,
          left: x - 56,
          backgroundColor: "white",
        }}
      >
        <Menu.Item onClick={() => handlePopupClick()}>
          Open Link in New Tab
          <Icon name='external alternate' />
        </Menu.Item>
      </Menu>
    </div>
  );
};

export default CustomContextMenu;
